module.exports = __webpack_public_path__ + "img/boy.fa77c8c5.png";